module.exports = __webpack_public_path__ + "img/purchase-icon.c4dd93df.svg";